/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import {
    Container,
    Grid,
    Breadcrumbs,
    Link,
    Typography,
    CircularProgress,
    Backdrop,
    Snackbar
} from "@material-ui/core";
import "date-fns";
import Widget from "../../components/Widget/Widget";
import Alert from '@material-ui/lab/Alert';

//icons
import EqualizerIcon from "@material-ui/icons/Equalizer";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Table from "./components/Table/Table";
import Form from "./components/Form/Form";

//context
import { useVendorState } from "../../context/VendorContext";

import {
  fetch3PReport,
  fetchOrderMetricsStats,
  fetchShareOfVoiceReport,
  generateOrderMetricsData,
  fetchGeographicInsightsReport,
  fetchCampaignReports,
  fetchSalesTrafficReports,
  fetchVendorSalesReport,
  fetchJSSegmentHistory,
  catalogRefresh,
  fetchSearchTermsReport,
  fetchKeywordsReport
} from "../../http/api";

import useStyles from "./styles";

export default function Charts(props) {
    const exportFunctionRef = useRef();
    //global
    const classes = useStyles();
    const [mainTableData, setmainTableData] = useState([]);
    var vendorState = useVendorState();

    // const Alert = React.forwardRef(function Alert(props, ref) {
    //     return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    //   });

    console.log('Vendor Stateee: ', vendorState?.list?.[0]?.vendorcode)
    const [selectedVendor, setSelectedVendor] = useState('');
    const [selectedReportType, setSelectedReportType] = useState('');
    const [segmentId, setSegmentId] = useState('');
    const [maxDuration, setMaxDuration] = useState('');
    const [snackBar, handleSnackBar] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState('');
    console.log(vendorState);
    // local
    const [fullPageLoader, setfullPageLoader] = useState(false);

    useEffect(() => {
        async function fetchData() {
            try {
                const [filteredData, maxDuration] = await fetchOrderMetricsStats(selectedVendor, selectedReportType);
                setmainTableData(filteredData);
                setMaxDuration(maxDuration)
            } catch (error) {
                console.error(error);
            } finally {
                setfullPageLoader(false);
            }
        }

        fetchData();

        return () => {
            setMaxDuration('')
            setmainTableData([]);
        };

    }, [selectedVendor, selectedReportType]);

    const generateReport = async (
      vendorCode,
      reportType,
      startDate,
      endDate
    ) => {
      let data;
      try {
        setfullPageLoader(true);
        switch (reportType) {
          case "ordermetricsday":
          case "ordermetricshour":
          case "ordermetricsasinweek":
          case "ordermetricsasinday":
          case "ordermetricsasinhour":
            data = await generateOrderMetricsData(
              vendorCode,
              reportType,
              startDate,
              endDate
            );
            break;
          case "3preport":
            data = await fetch3PReport(vendorCode, startDate, endDate);
            break;
          case "shareofvoice":
            data = await fetchShareOfVoiceReport(vendorCode, startDate, endDate);
            break;
          case "geographicinsights":
            data = await fetchGeographicInsightsReport(
              vendorCode,
              startDate,
              endDate
            );
            break;
          case "campaignreports":
            data = await fetchCampaignReports();
            break;
          case "salestraffic":
            data = await fetchSalesTrafficReports(
              vendorCode,
              startDate,
              endDate
            );
            break;
          case "vendorsalesreport":
            data = await fetchVendorSalesReport(vendorCode, startDate, endDate);
            break;
        case "jssegmentreports":
            data = await fetchJSSegmentHistory(segmentId, startDate, endDate);
            break;
        case "catalogRefresh":
            data = await catalogRefresh(vendorCode);
            break;
        case "searchtermsreport":
            data = await fetchSearchTermsReport();
            break;
        case "keywordsreport":
            data = await fetchKeywordsReport();
            break;
        default:
        }
        handleSnackBar(true);
        setSnackBarMessage(data?.message);
      } catch (err) {
        handleSnackBar(true);
        setSnackBarMessage(err?.message || err);
        console.error(err);
      } finally {
        setfullPageLoader(false);
      }
    };

    return (
        <>
            <Container maxWidth={false}>
                <PageTitle
                    title="Order Metrics"
                    breadCrump={
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link
                                color="inherit"
                                className={classes.link}
                            >
                                Operations
                            </Link>
                            <Typography className={classes.link}>
                                <EqualizerIcon color="primary" className={classes.icon} />
                                Order Metrics
                            </Typography>
                        </Breadcrumbs>
                    }
                />
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        {<Widget
                            upperTitle
                            noBodyPadding
                            bodyClass={classes.tableOverflow}
                            header={
                                <div className={classes.mainChartHeader}>
                                    <Typography
                                        variant="h2"
                                        gutterBottom
                                        style={{
                                            fontWeight: 600,
                                            fontSize: 20,
                                            color: "black",
                                        }}
                                    >
                                        {`Historic Data`}
                                    </Typography>
                                </div>
                            }
                        >
                            <Table ref={exportFunctionRef} tableData={mainTableData} />
                        </Widget>}
                    </Grid>
                    <Grid item xs={12} >
                        <Widget
                            upperTitle
                            noBodyPadding
                            bodyClass={classes.tableOverflow}
                            header={
                                <div className={classes.mainChartHeader}>
                                    <Typography
                                        variant="h2"
                                        gutterBottom
                                        style={{
                                            fontWeight: 600,
                                            fontSize: 20,
                                            color: "black",
                                        }}
                                    >
                                        {`Upload Historic Data`}
                                    </Typography>
                                </div>
                            }
                        >
                            {vendorState?.list ? <Form
                                selectedVendor={selectedVendor}
                                setSelectedVendor={setSelectedVendor}
                                selectedReportType={selectedReportType}
                                setSelectedReportType={setSelectedReportType}
                                vendorList={vendorState?.list ? [{ vendorcode: 'ALL', vendorname: 'All' }, ...vendorState.list] : []}
                                maxDuration={maxDuration}
                                generateReport={generateReport}
                                segmentId={segmentId}
                                setSegmentId={setSegmentId}
                            /> : <></>}
                        </Widget>
                    </Grid>
                </Grid>
                <Backdrop
                    className={classes.backdrop}
                    open={fullPageLoader}
                // onClick={() => setfullPageLoader(false)}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }} open={snackBar} autoHideDuration={6000} onClose={handleSnackBar}>
                    <Alert severity="success" sx={{ width: '100%' }}>
                        {snackBarMessage}
                    </Alert>
                </Snackbar>
            </Container>
        </>
    );
}
